import AppComponent from "./components/app-component";
import './css/App.css'

function App() {
  return (
    <AppComponent></AppComponent>
  );
}

export default App;
